<template>
  <div class="container">
    <svg
      id="el"
      width="100%"
      height="100%"
      viewBox="0 0 3099 1212"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1859.77 423.45C1877.35 399.791 1886.76 371.062 1886.6 341.588C1886.43 312.115 1876.7 283.492 1858.86 260.03L1761.61 132.11L1661.18 0H1354.61L1596.3 320.31C1600.03 325.246 1602.05 331.264 1602.05 337.45C1602.05 343.636 1600.03 349.654 1596.3 354.59L1354.61 674.9H1673.02L1761.61 555.61L1859.77 423.45Z"
        fill="#0F3565"
      />
      <path
        d="M1407.86 423.45C1425.44 399.791 1434.85 371.062 1434.69 341.588C1434.52 312.115 1424.79 283.492 1406.95 260.03L1309.7 132.09L1209.3 0H902.69L1144.3 320.31C1148.02 325.248 1150.04 331.265 1150.04 337.45C1150.04 343.635 1148.02 349.652 1144.3 354.59L902.69 674.9H1221.1L1309.7 555.61L1407.86 423.45Z"
        fill="#1F497D"
      />
      <path
        d="M955.95 423.45C973.526 399.79 982.939 371.06 982.773 341.586C982.607 312.113 972.871 283.491 955.03 260.03L857.78 132.09L757.35 0H450.78L692.42 320.31C696.148 325.246 698.165 331.264 698.165 337.45C698.165 343.636 696.148 349.654 692.42 354.59L450.78 674.9H769.19L857.78 555.61L955.95 423.45Z"
        fill="#0F3565"
      />
      <path
        d="M505.17 423.45C522.758 399.793 532.182 371.062 532.026 341.585C531.869 312.107 522.138 283.478 504.3 260.01L407.01 132.09L306.58 0H0L241.65 320.31C245.374 325.248 247.388 331.265 247.388 337.45C247.388 343.635 245.374 349.652 241.65 354.59L0 674.9H318.41L407.01 555.61L505.17 423.45Z"
        fill="#1F497D"
      />
    </svg>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'AnimatedLoad',
  mounted() {
    this.animate()
  },

  methods: {
    animate() {
      anime
        .timeline({
          targets: '#el path',
          easing: 'easeInOutQuad',
          delay: anime.stagger(250),
          loop: true,
        })
        .add({
          opacity: [0, 1],
          duration: 450,
        })
        .add(
          {
            translateX: [0, 500],
            duration: 1000,
          },
          0
        )
        .add(
          {
            opacity: [1, 0],
            duration: 450,
          },
          1200
        )
    },
  },
}
</script>

<style scoped>
#el path {
  opacity: 0;
}
</style>
